import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {InvoiceState} from './slicer';

import './thunk';

import {getInvoice, getInvoiceReport, getInvoiceTransaction, getInvoiceYears} from './thunk';

export const invoiceBuilder = (builder: ActionReducerMapBuilder<InvoiceState>) => {
  builder
    .addCase(getInvoiceYears.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getInvoiceYears.fulfilled, (state: any, action: any) => {
      state.invoiceYears = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getInvoiceYears.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
  builder
    .addCase(getInvoiceReport.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getInvoiceReport.fulfilled, (state: any, action: any) => {
      state.report = action.payload;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getInvoiceReport.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
  builder
    .addCase(getInvoiceTransaction.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getInvoiceTransaction.fulfilled, (state: any, action: any) => {
      state.transaction = [];
      action.payload?.data?.additions?.map((addition) => {
        state.transaction.push({...addition, type: 'addition'});
      });
      action.payload?.data?.deductions?.map((deduction) => {
        state.transaction.push({...deduction, type: 'deduction'});
      });
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getInvoiceTransaction.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
  builder
    .addCase(getInvoice.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getInvoice.fulfilled, (state: any, action: any) => {
      state.invoices = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getInvoice.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
